module.exports = __webpack_public_path__ + "static/tsc-logo-fb8408adb677c2c8999c99730894cb91.svg";